import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-compass-3-line text-xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">海角论坛</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                海角论坛是深受用户喜爱的网络社区平台，汇聚海量真实分享内容，涵盖技术、生活、娱乐、游戏等多元版块。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门版块</h4>
              <ul className="space-y-2">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    版块分类
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-xs"></i>
                  </div>
                  support@haijiaoluntan.com
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-xs"></i>
                  </div>
                  在线客服：工作日 9:00-18:00
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; 2024 海角论坛 版权所有 | 京ICP备XXXXXXXX号
              </p>
              <div className="flex items-center gap-6">
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                  用户协议
                </a>
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                  隐私政策
                </a>
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                  社区规范
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}